import styled from 'styled-components';
import theme from 'styles/theme';

export const SubtitleWrapper = styled.div`
  margin-bottom: 12px;
  color: ${theme.colors.gray600};

  p {
    margin: 0;
  }
`;
